/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { Tokens } from '@jda/lui-common-component-library-mui5';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  selectedListItem: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    width: Tokens.spacing['$sp-152'],
    borderBottom: "1px solid #e0e0e0",
    backgroundColor: theme.palette.background.paper,
    "&:hover": {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(206, 206, 250, 0.0902)!important' : 'rgba(0, 0, 45, 0.0902)!important',
      borderRadius: Tokens.spacing['$sp-2'],
    },
  },
  listItem: {
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    "&.Mui-selected": {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(206, 206, 250, 0.0902)!important' : 'rgba(0, 0, 45, 0.0902)!important',
       borderRadius: Tokens.spacing['$sp-2'],
    },
    "&:hover": {
      backgroundColor: theme.palette.mode === 'dark' ? 'rgba(206, 206, 250, 0.0902)!important' : 'rgba(0, 0, 45, 0.0902)!important',
      borderRadius: Tokens.spacing['$sp-2'],
    }
  },
  searchList: {
    position: "absolute",
    width: '100%',
    overflow: "scroll",
    backgroundColor: theme.palette.background.paper,
    boxShadow: `0px 12px 32px -16px ${theme.palette.mode === 'dark' ? 'rgba(210, 217, 254, 0.1608)' : 'rgba(0, 9, 50, 0.1216)'}, 0px 12px 60px 0px rgba(0, 0, 0, 0.1500)`,
    borderWidth: Tokens.spacing['$sp-0-25'],
    borderStyle: 'solid',
    borderColor: theme.palette.mode === 'dark' ? 'rgba(210, 217, 254, 0.1608)' : 'rgba(0, 9, 50, 0.1216)',
     borderRadius: Tokens.spacing['$sp-2'],
    zIndex: 1400,
    padding: Tokens.spacing['$sp-2'],
    paddingRight: Tokens.spacing['$sp-1'],
  },
  noItem: {
    color: 'grey',
    padding: Tokens.spacing['$sp-4']
  },
  boxHeight: {
    maxHeight: 273
  }
}));
